import { FC, ReactNode } from 'react'
import { Link } from '@/libs'
import { Profile } from '@/ui/components'

const Dropdown: FC<DropdownComponentProps> = (props): ReactNode => {
    const { links, user, show } = props

    if (show) return (
        <div className='absolute border border-[#424242] top-6 right-0 z-50 my-4 w-48 text-base list-none bg-[#262626] rounded-md divide-y divide-[#424242]'>
            { user && <Profile /> }

            {
                links?.map((link, index: number) => {
                    const { onClick, onHref, name } = link

                    const radius = index === 0 ? '' : index === links.length - 1 ? 'rounded-b-md' : ''

                    if (link?.hasOwnProperty('onHref') && onHref) return (
                        <Link key={name} href={onHref} className={`text-[#CDD5DA] font-medium cursor-pointer flex items-center py-2 px-4 text-[15px] hover:bg-[#404040] transition-all ease-in-out duration-500 ${radius}`}>
                            {name}
                        </Link>
                    )

                    if (link?.hasOwnProperty('onClick') && onClick) return (
                        <div key={name} onClick={onClick} className={`text-[#CDD5DA] font-medium cursor-pointer flex items-center py-2 px-4 text-[15px] hover:bg-[#404040] transition-all ease-in-out duration-500 ${radius}`}>
                            {name}
                        </div>
                    )
                })
            }
        </div>
    )
}

export default Dropdown
